import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { PopupDialogService } from '../components/shared/popup-dialog/popup-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class AppRouteService {

  constructor(
    private popupDialogService: PopupDialogService,
    private location: Location
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (this.popupDialogService.data != null) {
      this.popupDialogService.closeDialog()
      this.location.go(state.url);
      return false
    }

    return true
  }
}
